module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-5-pzk-002.c4ba5579.json").toString();